<template>
	<div class="container pb-10">
		<div class="flex flex-col items-start sm:flex-row sm:justify-between sm:items-center gap-2 py-2 mb-4">
			<h1 class="page-title">Oferte configurator EU</h1>
			<div class="flex justify-end item-center">
				<v-badge bordered color="error" :content="reveniriCounts.due"
					:value="user.rol != 'admin' && reveniriCounts.due > 0" offset-x="20" overlap>
					<v-badge bordered color="warning" :content="reveniriCounts.today"
						:value="user.rol != 'admin' && reveniriCounts.today > 0" offset-x="0" overlap>
						<v-btn to="/oferte-productie/lista-reveniri-eu" color="white" class="uppercase">Lista
							reveniri EU</v-btn></v-badge></v-badge>
			</div>
		</div>

		<v-dialog v-model="visibleInteresModal" max-width="400px">
			<v-card>
				<v-form ref="changeInteresForm" v-model="interesForm" @submit.prevent="saveInteresStatus">
					<v-card-title>
						Schimba statusul
					</v-card-title>
					<v-card-text>
						<v-select v-model="currentOffer.status"
							:items="['e interesat', 'contact initial', 'nu a raspuns', 'revenim', 'nu e interesat']"
							label="Alege" outlined :rules="[rules.required]">
						</v-select>
						<v-text-field v-model="currentOffer.details" label="Detalii suplimentare"
							outlined></v-text-field>
						<v-menu v-if="currentOffer.status == 'revenim'" v-model="datepickerMenu"
							:close-on-content-click="false" :nudge-right="40" transition="scale-transition"
							min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="formattedReturnDate" label="Data revenire"
									prepend-inner-icon="mdi-calendar" readonly outlined :rules="[rules.required]"
									v-bind="attrs" v-on="on"></v-text-field>
							</template>
							<v-date-picker v-model="currentOffer.returnDate" no-title :rules="[rules.required]"
								@input="datepickerMenu = false"></v-date-picker>
						</v-menu>
					</v-card-text>
					<div class="flex flex-row justify-end gap-2 px-6 pb-4">
						<v-btn color="blue-grey" class="uppercase" dark large
							@click="closeInteresModal">Anuleaza</v-btn>
						<v-btn color="teal" dark class="uppercase" large type="submit">Salveaza</v-btn>
					</div>
				</v-form>
			</v-card>
		</v-dialog>

		<div class="light-grey rounded mb-4 p-4">
			<div class="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-2 lg:gap-10 w-full">
				<div class="w-full lg:w-1/2 flex flex-row items-center gap-2">
					<v-text-field v-model="filterInput" clearable flat solo hide-details
						prepend-inner-icon="mdi-magnify" label="Cauta oferta dupa client"></v-text-field>
				</div>
				<div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
					<v-select ref="selectCountry" v-model="selectedCountry" class="w-full sm:w-52" :items="countryList"
						item-text="denumire" item-value="value" clearable @click:clear="$refs.selectCountry.blur()"
						label="Toate țările" solo hide-details>
						<template v-slot:item="{ item }">
							<span>
								{{ item.flag }} {{ item.denumire }}
							</span>
						</template>
						<template v-slot:selection="{ item }">
							<span>
								{{ item.flag }} {{ item.denumire }}
							</span>
						</template>
					</v-select>
					<div class="w-full sm:w-60">
						<v-menu v-model="monthpickerMenu" class="w-full" :close-on-content-click="false" left
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="monthText" class="date-field" label="Luna" solo
									prepend-inner-icon="mdi-calendar" hide-details readonly v-bind="attrs"
									v-on="on"></v-text-field>
							</template>
							<v-date-picker v-model="selectedMonth" no-title type="month"
								@input="changeMonth"></v-date-picker>
						</v-menu>
					</div>
				</div>
			</div>
		</div>

		<v-data-table :headers="headers" :items="filterBy(fenceEuLeads, filterInput)" item-key="id_cerere"
			:loading="loadingFenceLeads" show-expand single-expand :expanded.sync="expanded" :items-per-page="-1"
			hide-default-footer>
			<template v-slot:item.data="{ item }">
				{{ item.data | formatDate }}
			</template>
			<template v-slot:item.nume="{ item }">
				<div v-if="item.client_obj.name">
					{{ `${item.client_obj.surname} ${item.client_obj.name}` }}
				</div>
				<div v-else>-</div>
			</template>
			<template v-slot:item.sunat="{ item }">
				<Called :item="item" :user="user" leadType="eu" />
			</template>
			<template v-slot:item.interes="{ item }">
				<Interes :item="item" leadType="eu" @openModal="loadCurrentOffer" />
			</template>
			<template v-slot:item.trimisa="{ item }">
				<Sent :item="item" leadType="eu" />
			</template>
			<template v-slot:item.countryZone="{ item }">
				<div class="flex flex-row items-center gap-1">
					<span class="text-2xl">
						{{ displayFlag(item.country) }}
					</span>
					<span class="mb-0.5"> | {{ item.client_obj.judet.text }}</span>
				</div>
			</template>
			<template v-slot:item.suprafata="{ item }">
				<AreaTotal :item="item" />
			</template>
			<template v-slot:item.total="{ item }">
				<span class="font-medium">
					{{ item.gard_obj.pretTotal }}
				</span> eur
			</template>
			<template v-slot:expanded-item="{ headers, item }">
				<td colspan="2" class="bg-gray-100">
					<v-icon class="mx-1">mdi-arrow-right-bottom</v-icon>
				</td>
				<td :colspan="2" class="bg-gray-100">
					<div class="mt-3 mb-4 flex flex-col">
						<div>Email: {{ item.client_obj.email }}</div>
						<div v-if="item.client_obj.phone">Tel: {{ item.client_obj.phone }}</div>
					</div>
				</td>
				<td :colspan="2" class="bg-gray-100">
					<div class="mt-3 mb-4 flex flex-col gap-1">
						<div>Dim. gard: {{ fenceDimensions(item.gard_obj.dimensions) }}</div>
						<div v-if="fencePanels">{{ fencePanels(item.gard_obj) }}</div>
						<div v-if="fencePPs">{{ fencePPs(item.gard_obj) }}</div>
						<div v-if="fencePAs">{{ fencePAs(item.gard_obj) }}</div>
					</div>
				</td>
				<td :colspan="2" class="bg-gray-100">
					<div v-if="item.client_obj.message" class="bg-gray-100 p-2 rounded">
						<div class="font-medium">Mesaj client:</div>
						<div class="text-sm">{{ item.client_obj.message }}</div>

					</div>
				</td>
				<td colspan="3" class="bg-gray-100">
					<Prices :item="item" :eu-version="true" />
				</td>
			</template>
			<template v-slot:item.actions="{ item }">
				<Actions :item="item" :user="user" :today="today" :eu-version="true" />
			</template>
		</v-data-table>

		<!-- <pre>
			{{ fenceEuLeads }}
		</pre> -->
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import moment from "moment"
import flags from "@/assets/countries-flags.json"
import Called from "./OferteConfigurator/Called"
import Interes from "./OferteConfigurator/Interes"
import Sent from "./OferteConfigurator/Sent"
import AreaTotal from "./OferteConfigurator/AreaTotal"
import Prices from "./OferteConfigurator/Prices"
import Actions from "./OferteConfigurator/Actions"

export default {
	name: "OferteProductieConfiguratorEU",
	components: {
		Called,
		Interes,
		Sent,
		AreaTotal,
		Prices,
		Actions
	},
	data() {
		return {
			monthpickerMenu: false,
			selectedMonth: new Date().toISOString().substring(0, 7),
			selectedCountry: null,
			filterInput: "",
			expanded: [],
			headers: [
				{
					text: 'Nr.',
					align: 'start',
					sortable: false,
					value: 'id_cerere',
					width: '5%'
				},
				{
					text: 'Data',
					align: 'start',
					sortable: false,
					value: 'data',
					width: '5%'
				},
				{
					text: 'Client',
					align: 'start',
					sortable: false,
					value: 'nume',
				},
				{
					text: 'Sunat?',
					align: 'center',
					sortable: false,
					value: 'sunat',
					width: '5%'
				},
				{
					text: 'Interes',
					align: 'start',
					sortable: false,
					value: 'interes',
					width: '15%'
				},
				{
					text: 'Trimis oferta?',
					align: 'start',
					sortable: false,
					value: 'trimisa',
				},
				{
					text: 'Tara | zona',
					align: 'start',
					sortable: false,
					value: 'countryZone',
					width: '12%'
				},
				{
					text: 'Suprafata totala',
					align: 'start',
					sortable: false,
					value: 'suprafata',
				},
				{
					text: 'Pret total cu TVA',
					align: 'start',
					sortable: false,
					value: 'total',
					width: '10%'
				},
				{
					value: 'data-table-expand',
					width: '5%'
				},
				{
					value: 'actions',
					sortable: false,
					width: '5%'
				}
			],
			prices: {
				p_rama: 1.265, // %
				pp: 240, // eur
				pa: 140, // eur
				pap: 240, // eur
				shippingKM: 0.6,
			},
			old_prices: {
				p_rama: 1.27, // %
				pp: 237, // eur
				pa: 126, // eur
				pap: 254, // eur
				shippingKM: 0.6,
			},
			visibleInteresModal: false,
			interesForm: false,
			datepickerMenu: false,
			currentOffer: {
				id: null,
				status: null,
				details: null,
				returnDate: null
			},
			rules: {
				required: value => !!value || 'Câmp obligatoriu'
			},
			today: moment().format("YYYY-MM-DD"),
		};
	},
	computed: {
		...mapState("fenceLeads", ["fenceEuLeads", "loadingFenceLeads"]),
		monthText() {
			return this.$options.filters.formatMonth(this.selectedMonth)
		},
		countryList() {
			// map countries from fenceEuLeads to a list of unique countries with their corresponding flag
			const countries = this.fenceEuLeads.reduce((acc, oferta) => {
				const country = oferta.country;
				if (country && !acc.some(c => c.value == country)) {
					const countryDetails = flags[country.toUpperCase()]
					acc.push({ value: country, denumire: countryDetails.name, flag: countryDetails.emoji });
				}
				return acc.sort((a, b) => a.denumire.localeCompare(b.denumire));
			}, []);
			return countries;
		},
		firstDay() {
			return new Date(this.selectedMonth).toISOString().split('T')[0]
		},
		lastDay() {
			return new Date(new Date(this.selectedMonth).getFullYear(), new Date(this.selectedMonth).getMonth() + 1, 1).toISOString().split('T')[0]
		},
		user() {
			return this.$store.getters.loggedUser;
		},
		formattedReturnDate() {
			return this.$options.filters.formatDate(this.currentOffer.returnDate)
		},
		reveniriCounts() {
			return this.$store.getters.lista_reveniri_configurator_gard_eu_counts
		}
	},
	methods: {
		...mapActions("fenceLeads", ["fetchFenceLeads"]),
		escapeRegExp(s) {
			return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
		},
		filterBy(list, value) {
			if (!value) {
				value = ""
			}
			const words = value
				.split(/\s+/g)
				.map((s) => s.trim())
				.filter((s) => !!s);

			const hasTrailingSpace = value.endsWith(" ");

			const searchRegex = new RegExp(
				words
					.map((word, i) => {
						if (i + 1 === words.length && !hasTrailingSpace) {
							// The last word - ok with the word being "startswith"-like
							return `(?=.*\\b${this.escapeRegExp(word)})`;
						} else {
							// Not the last word - expect the whole word exactly
							return `(?=.*\\b${this.escapeRegExp(word)}\\b)`;
						}
					})
					.join("") + ".+",
				"i"
			);

			// return list.filter((oferta) => searchRegex.test(this.fullName(oferta.client_obj.surname, oferta.client_obj.name)))

			return list.filter((oferta) => {
				const fullName = this.fullName(oferta.client_obj.surname, oferta.client_obj.name);
				const email = oferta.client_obj.email || '';
				const searchableText = `${fullName} ${email}`.trim();
				const countryCode = oferta.country;

				// Text search match
				const matchesSearch = searchRegex.test(searchableText);

				// Country filter (if specific country is selected)
				const matchesCountry = !this.selectedCountry
					|| countryCode === this.selectedCountry;

				return matchesSearch && matchesCountry;
			});
		},
		closeInteresModal() {
			this.visibleInteresModal = false
			this.$nextTick(() => {
				this.currentOffer = Object.assign({}, {})
			})
		},
		changeMonth() {
			this.monthpickerMenu = false
			this.fetchLeadsConfigurator()
		},
		fetchLeadsConfigurator() {
			this.fetchFenceLeads({ type: "eu", fromDate: this.firstDay, toDate: this.lastDay })
		},
		loadCurrentOffer(payload) {
			this.currentOffer = Object.assign({}, { ...payload })
			this.visibleInteresModal = true
		},
		async saveInteresStatus() {
			const valid = await this.$refs.changeInteresForm.validate();

			if (valid) {
				this.$store.dispatch("updateInteresStatus", {
					id: this.currentOffer.id,
					interes: this.currentOffer.status,
					details: this.currentOffer.details,
					return_date: this.currentOffer.returnDate,
					user_id: this.user.id_user,
					leadType: 'eu'
				});
				this.closeInteresModal();
			}
		},
		fullName(firstname, lastname) {
			return `${firstname} ${lastname}`
		},
		findCerereCounty(judet) {
			const county = this.counties.find((item) => item.nume_judet == judet)
			return county ? Number(county.id_judet) : 0
		},
		displayFlag(country) {
			if (country && country != 'ro') {
				const flagCountry = flags[country.toUpperCase()]
				return flagCountry.emoji
			} else {
				return
			}
		},
		fenceDimensions(dimensions) {
			return `LT ${dimensions.lt} m | HT ${dimensions.ht} m | HP ${dimensions.hp} m`
		},
		fencePanels(gard_obj) {
			const panelStr = gard_obj.configuration.panouri.is ? `Panou ${gard_obj.configuration.panouri.buc} buc - ${gard_obj.lPanou.toFixed(2)}(L) x ${gard_obj.hPanou * 1000}(H) mm` : ''
			return `${panelStr}`
		},
		fencePPs(gard_obj) {
			let ppDimStr = ''
			gard_obj.configuration.poarta_p.items.forEach((item, idx) => {
				if (idx != 0) {
					ppDimStr += ' & '
				}
				ppDimStr += `${item.latime_gol}(L) mm`
			})
			const panelStr = gard_obj.configuration.poarta_p.is ? `PP ${gard_obj.configuration.poarta_p.buc} buc - ${ppDimStr}` : ''
			return `${panelStr}`
		},
		fencePAs(gard_obj) {
			let paDimStr = ''
			gard_obj.configuration.poarta_a.items.forEach((item, idx) => {
				if (idx != 0) {
					paDimStr += ' & '
				}
				const ppIncStr = item.pp_included ? ` cu PP inc. (${item.latime_pp} mm)` : ''
				paDimStr += `${item.tip}${ppIncStr} - ${item.latime_gol}(L) mm`
			})

			const panelStr = gard_obj.configuration.poarta_a.is ? `PA ${gard_obj.configuration.poarta_a.buc} buc - ${paDimStr}` : ''
			return `${panelStr}`
		},
		returnTimeframeNumber(str) {
			if (str) {
				if (str == "so bald wie möglich") {
					return 1;
				} else if (str == "bald") {
					return 2;
				} else if (str == "innerhalb eines halben Jahres") {
					return 3;
				} else if (str == "Ich schaue es mir gerade erst an") {
					return 4;
				}
			}
		},
		returnTimeframeColor(str) {
			if (str) {
				if (str == "so bald wie möglich" || str == "bald") {
					return "green";
				} else {
					return "grey";
				}
			}
		},
		panouriPrice(oferta) {
			let price = oferta.client_obj.judet.price;
			if (oferta.gard_obj.configuration.panouri.panelFrame) {
				price = (price * this.prices.p_rama).toFixed(2);
				if (Number(oferta.id_cerere) < 542) {
					price = (price * this.old_prices.p_rama).toFixed(2);
				}
			}

			if (oferta.gard_obj.model == "vertical") {
				price += 15;
			}
			return Number(price);
		},
		poarta_pietonalaPrice(oferta) {
			let price = oferta.client_obj.judet.price + this.prices.pp;

			if (Number(oferta.id_cerere) < 542) {
				price = oferta.client_obj.judet.price + this.old_prices.pp;
			}

			if (oferta.gard_obj.model == "vertical") {
				price += 15;
			}
			return price;
		},
		poarta_autoPriceStr(oferta) {
			let pricePA = oferta.client_obj.judet.price + this.prices.pa;
			let pricePAP = oferta.client_obj.judet.price + this.prices.pap;

			if (Number(oferta.id_cerere) < 542) {
				pricePA = oferta.client_obj.judet.price + this.old_prices.pa;
				pricePAP = oferta.client_obj.judet.price + this.old_prices.pap;
			}

			if (oferta.gard_obj.model == "vertical") {
				pricePA += 15;
				pricePAP += 15;
			}
			let str = "";

			if (oferta.gard_obj.configuration.poarta_a.items) {
				if (this.poarta_aap_buc(oferta.gard_obj.configuration) > 0) {
					if (
						this.poarta_ab_buc(oferta.gard_obj.configuration) > 0 ||
						this.poarta_ac_buc(oferta.gard_obj.configuration) > 0
					) {
						str = `${pricePA} & ${pricePAP}`;
					} else {
						str = `${pricePAP}`;
					}
				} else {
					str = `${pricePA}`;
				}
			} else {
				str = `${pricePA}`;
			}
			return str;
		},
		poarta_ab_buc(configuration) {
			let count = 0;
			configuration.poarta_a.items.forEach((poarta) => {
				if (poarta.tip == "batanta") {
					count++;
				}
			});
			return count;
		},
		poarta_ac_buc(configuration) {
			let count = 0;
			configuration.poarta_a.items.forEach((poarta) => {
				if (poarta.tip == "culisanta") {
					count++;
				}
			});
			return count;
		},
		poarta_aap_buc(configuration) {
			let count = 0;
			configuration.poarta_a.items.forEach((poarta) => {
				if (poarta.tip == "autoportanta") {
					count++;
				}
			});
			return count;
		},
		suprafataTotala(a, b, c) {
			let s = Number(a) + Number(b) + Number(c);
			return s.toFixed(2);
		},
	},
	created: function () {
		this.fetchLeadsConfigurator()
	},
	mounted: function () {
		this.$store.dispatch("fetchListaReveniriConfiguratorGardEuCounts");
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span.dot {
	border-radius: 100px;
	width: 10px;
	height: 10px;
	display: inline-block;
	margin: 0 5px 0 15px;
}

span.square {
	width: 12px;
	height: 12px;
	display: inline-block;
	margin: 0 5px 0 10px;
}

::v-deep .v-data-table__mobile-table-row {
	display: block !important;
	margin-bottom: 12px;
}
</style>
